import { css } from "@emotion/react";

export const SiderStyle = {
  self: css`
    width: 300px;
    height: 100%;
  `,
};
